import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CenterStage from '../../Components/CenterStage/CenterStage';
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import ImageCard from '../../Components/ImageCard/ImageCard';

import imgStage from '../../assets/Services/MobileService/MobileService.jpg';
import imgMobileService from '../../assets/Services/MobileService/HFNeverFar.jpg';
import imgPreventativeMaintenance from '../../assets/Services/PreventativeMaintainance/PreventativeMaintainance/Stage.jpg';
import imgFluidManagement from '../../assets/Services/FluidManagement/fluidMangement.jpg';
import imgAssemblyAndInstallation from '../../assets/Services/AssemblyAndInstallation/AssemblyAndInstallation/Stage.jpg';
import imgRepairAndOverhaul from '../../assets/Services/RepairAndOverHaul/RepairAndOverhaul/Stage.jpg';
import imgEngineering from '../../assets/Services/Engineering/Engineering_Centerspread.jpg';
import imgProduction from '../../assets/Services/Production/Production/Production_Centerspread.jpg';
import imgLogistics from '../../assets/Services/Logistics solutions/Logistics solutions/Logistics_Centerspread.jpg';
import imgDigitalServices from '../../assets/Services/Digital Services/Digital Services/Digital_Centerspread.jpg';
import imgTraining from '../../assets/Services/HydraulicAcademy/HydraulicAcademy.jpg';

function ServicesPage() {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    return (
        <div>
            <div>
                <CenterStage
                    imageSrc={imgStage}
                    title={"HYDRAULIC SERVICES FROM HANSA-FLEX IRELAND"}
                    paragraph={"HANSA-FLEX is more than a supplier of hydraulic components. From our branches across Ireland we keep your systems running: rapid on-site breakdown response, planned preventative maintenance, oil care, cylinder repair, in-house production and full engineering support. Whatever keeps your plant moving, we service it."}
                />
            </div>

            <SectionHeader
                title={"THE COMPLETE HANSA-FLEX SERVICE PORTFOLIO"}
                subtitle={"Our engineers support you across the entire life cycle of your hydraulic systems, from first design through to inspection, repair and overhaul."}
            />

            <div>
                <Container className="custom-container">
                    <Row>
                        <Col sm={12} md={6} lg={8}>
                            <ImageCard
                                image={imgMobileService}
                                learnMoreLink={"/services/mobile-rapid-hydraulic-service"}
                                title="Mobile rapid hydraulic service, 24/7 across Ireland"
                                desc={"When a hose line fails, production stops. Our fully equipped Rapid Hydraulic Service vans reach you fast, manufacture the replacement hose line on site and get your machine back into operation, day or night."}
                            />
                        </Col>

                        <Col sm={12} md={6} lg={4}>
                            <ImageCard
                                image={imgPreventativeMaintenance}
                                learnMoreLink={"/services/preventative-maintenance"}
                                title="Preventative maintenance and statutory inspection"
                                desc={"Scheduled hose management, X-CODE identification and documented inspections keep you compliant and prevent the unplanned downtime that costs the most."}
                            />
                        </Col>

                        <Col sm={12} md={6} lg={4}>
                            <ImageCard
                                image={imgFluidManagement}
                                learnMoreLink={"/services/fluid-management"}
                                title="Fluid management and oil care"
                                desc={"Most hydraulic failures start with contaminated oil. We analyse, filter and clean your hydraulic fluid so components reach their full service life."}
                            />
                        </Col>

                        <Col sm={12} md={6} lg={4}>
                            <ImageCard
                                image={imgAssemblyAndInstallation}
                                learnMoreLink={"/services/assembly-and-installation"}
                                title="Assembly, installation and plant modernisation"
                                desc={"From installing pipe and hose line systems to modernising and optimising existing plant, our fitters handle projects of any scale on your site."}
                            />
                        </Col>

                        <Col sm={12} md={6} lg={4}>
                            <ImageCard
                                image={imgRepairAndOverhaul}
                                learnMoreLink={"/services/repair-and-overhaul"}
                                title="Repair and overhaul of hydraulic components"
                                desc={"Hydraulic cylinders, pumps, motors and pressure accumulators are reconditioned in our workshops to as-new condition, usually far more economically than replacement."}
                            />
                        </Col>

                        <Col sm={12} md={6} lg={8}>
                            <ImageCard
                                image={imgEngineering}
                                learnMoreLink={"/services/engineering"}
                                title="Engineering: from concept to commissioned system"
                                desc={"Our design engineers develop bespoke hydraulic power units, prototypes and complete systems. Engineered by HANSA-FLEX means you get a single partner responsible for design, manufacture, testing and commissioning."}
                            />
                        </Col>

                        <Col sm={12} md={6} lg={4}>
                            <ImageCard
                                image={imgProduction}
                                learnMoreLink={"/services/production"}
                                title="Series production and customised assembly"
                                desc={"Ready-to-install assemblies produced to your drawing, in the quantities you need, delivered to your line."}
                            />
                        </Col>

                        <Col sm={12} md={6} lg={4}>
                            <ImageCard
                                image={imgLogistics}
                                learnMoreLink={"/services/logistics-solutions"}
                                title="Logistics solutions and warehouse management"
                                desc={"Kanban delivery, kitting, hydraulic workshop containers and works-in-works arrangements put the right part in the right place at the right time."}
                            />
                        </Col>

                        <Col sm={12} md={6} lg={4}>
                            <ImageCard
                                image={imgDigitalServices}
                                learnMoreLink={"/services/digital-services"}
                                title="Digital services, EDI and scanner solutions"
                                desc={"Connect your procurement directly to ours. EDI, BMEcat catalogues and barcode scanner ordering remove paperwork from your supply chain."}
                            />
                        </Col>

                        <Col sm={12} md={6} lg={8}>
                            <ImageCard
                                image={imgTraining}
                                learnMoreLink={"/services/hydraulic-training-and-seminars"}
                                title="Hydraulic training and seminars"
                                desc={"The HANSA-FLEX Hydraulic Academy runs practical training for maintenance teams and engineers, covering hydraulic fundamentals, hose line assembly, oil care and statutory inspection duties. Courses run at our premises or in house at yours."}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default ServicesPage;
